/* AFS14 - schuifje voor en na, pijlen onder een rij, en "Read more" bij lange reviews.
   Draait opnieuw bij shopify:section:load, zodat het ook in de theme-editor werkt. */
(function () {
  'use strict';

  /* V17: op een telefoon liep het schuifje vast. Drie oorzaken, gemeten met echte touch:
     1. Een duim die eerst een paar pixels omhoog of omlaag gaat, gaf de beweging aan de pagina
        (touch-action: pan-y) en het schuifje stopte halverwege. Nu ligt er een brede grijpstrook
        over de streep en het knopje met touch-action: none; daar begint het schuiven altijd.
     2. Bij aanraken sprong de streep meteen naar de vinger, ook als je alleen wilde scrollen.
        Nu schuift hij mee vanaf waar hij staat, en springt hij alleen bij een echte tik.
     3. Een beweging die vooral verticaal begint, is scrollen: die laat het schuifje met rust.
     Met de muis werkt het zoals voorheen: de streep volgt de cursor. */
  function bootBA(root) {
    root.querySelectorAll('[data-afs14-ba]').forEach(function (el) {
      if (el.__afs14) return; el.__afs14 = true;
      var drag = null, raf = 0, want = 50;
      function cur() { return parseFloat(el.style.getPropertyValue('--pos')) || +el.getAttribute('aria-valuenow') || 50; }
      function setPct(p) {
        want = Math.max(2, Math.min(98, p));
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          el.style.setProperty('--pos', want + '%');
          el.setAttribute('aria-valuenow', Math.round(want));
        });
      }
      function pctAt(x) { var r = el.getBoundingClientRect(); return r.width ? (x - r.left) / r.width * 100 : null; }
      el.addEventListener('pointerdown', function (e) {
        if (e.button > 0) return;
        drag = {
          id: e.pointerId, x0: e.clientX, y0: e.clientY, p0: cur(), live: false,
          grab: !!(e.target.closest && e.target.closest('.afs14-ba__grab')),
          mouse: e.pointerType === 'mouse'
        };
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
        if (drag.mouse) { var p = pctAt(e.clientX); if (p !== null) setPct(p); drag.live = true; }
      });
      el.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var w = el.getBoundingClientRect().width; if (!w) return;
        if (drag.mouse) { var p = pctAt(e.clientX); if (p !== null) setPct(p); return; }
        var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
        if (!drag.live) {
          if (!drag.grab && Math.abs(dy) > 6 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          if (Math.abs(dx) < 4 && !drag.grab) return;
          drag.live = true;
        }
        setPct(drag.p0 + dx / w * 100);
      });
      function end(e) {
        if (!drag || e.pointerId !== drag.id) return;
        if (e.type === 'pointerup' && !drag.live && !drag.grab &&
            Math.abs(e.clientX - drag.x0) < 8 && Math.abs(e.clientY - drag.y0) < 8) {
          var p = pctAt(e.clientX); if (p !== null) setPct(p);
        }
        drag = null;
      }
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { el.addEventListener(n, end); });
      el.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        setPct(cur() + (e.key === 'ArrowLeft' ? -5 : 5));
      });
    });
  }

  /* Pijlen schuiven de rij precies één kaart op. Ze gaan uit aan het begin en eind. */
  function bootNav(root) {
    root.querySelectorAll('[data-afs14-nav]').forEach(function (nav) {
      if (nav.__afs14) return; nav.__afs14 = true;
      var rail = document.getElementById(nav.getAttribute('data-afs14-nav'));
      if (!rail) return;
      var prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]');
      function step() { var c = rail.children[0]; if (!c) return rail.clientWidth; var gap = parseFloat(getComputedStyle(rail).columnGap) || 12; return c.getBoundingClientRect().width + gap; }
      function state() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        nav.hidden = max <= 0;
      }
      [prev, next].forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: step() * (+b.getAttribute('data-dir')), behavior: 'smooth' }); });
      });
      rail.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state);
      state();
    });
  }

  /* "Read more" verschijnt alleen als de tekst echt is afgekapt. */
  function bootMore(root) {
    root.querySelectorAll('[data-afs14-rc]').forEach(function (card) {
      if (card.__afs14) return; card.__afs14 = true;
      var q = card.querySelector('.afs14-rc__q'), btn = card.querySelector('.afs14-rc__more');
      if (!q || !btn) return;
      function check() { if (!card.classList.contains('is-open')) btn.hidden = q.scrollHeight <= q.clientHeight + 2; }
      btn.addEventListener('click', function () {
        var open = card.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        btn.setAttribute('aria-expanded', open);
      });
      check();
      window.addEventListener('resize', check);
    });
  }

  /* Knopjes boven de bestsellers: wisselen de rij naar een andere collectie op dezelfde
     pagina. De knop eronder volgt mee, met link en tekst van de gekozen collectie. */
  function bootTabs(root) {
    root.querySelectorAll('[data-afs14-tabs]').forEach(function (bar) {
      if (bar.__afs14) return; bar.__afs14 = true;
      var sec = bar.closest('.afs14-bs') || document;
      var tabs = bar.querySelectorAll('[data-afs14-tab]');
      var cta = sec.querySelector('[data-afs14-cta]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          var i = tab.getAttribute('data-afs14-tab');
          var panel = sec.querySelector('[data-afs14-panel="' + i + '"]');
          if (!panel) return;
          e.preventDefault();
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on); });
          sec.querySelectorAll('[data-afs14-panel]').forEach(function (p) { p.hidden = p !== panel; });
          panel.scrollLeft = 0;
          if (cta) {
            cta.href = panel.getAttribute('data-url') || cta.href;
            var lab = cta.querySelector('[data-afs14-cta-label]');
            if (lab) lab.textContent = i === '0' ? cta.getAttribute('data-all')
              : (cta.getAttribute('data-col') || '').replace('[collection]', tab.textContent.trim().toLowerCase());
          }
        });
      });
    });
  }

  function boot(root) { root = root || document; bootBA(root); bootNav(root); bootMore(root); bootTabs(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  else boot();
  window.addEventListener('load', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
